module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-bj-1.844684f8.jpg";